module.exports = __webpack_public_path__ + "static/media/img_homepage_menu_02-Resource_default.297754e5.png";